export const addressEntryForm = ({ formId, formName = 'broadband_address_form', formStartedId }) => ({
  form_id: formId,
  form_name: formName,
  form_type: 'comparison_journey',
  form_step_name: 'broadband_address_form',
  form_step_id: 'broadband_address_form-001',
  form_started_id: formStartedId,
  form_is_step_skipped: false,
  form_step_field: [
    {
      id: 'postcode-input',
      label: '',
      value: '',
      type: 'text'
    }
  ],
  org_brand: 'uswitch',
  org_product_category: 'broadband',
  org_subvertical: 'broadband',
  org_vertical: 'communications',
  org_vertical_group: 'home_services'
})

export const addressEntryBroadbandSpecificFields = ({ address, providerId, providerName }) => ({
  broadband_postcode: address?.postcode,
  broadband_address: address?.summaryline || address?.summaryLine,
  broadband_current_provider_id: providerId,
  broadband_current_provider: providerName
})
